import {TextInput} from '@/components/atoms'
import {SectionTitle} from '@/components/molecules'
import {PageContainer} from '@/components/organisms'

const BrandEdit = ({handleFormChange, brandFields, errors, languages, localFormData}) => {
  return (
    <PageContainer data-testid="product-edit-brand-content">
      <div className="">
        <div className="grid grid-cols-1">
          <SectionTitle label="Brand Information" />
          <div className="sc-border grid grid-cols-4 gap-4 pb-5">
            {/* Render fields without languages */}
            {brandFields
              ?.filter(field => !field.languages)
              ?.map(field => (
                <div key={field.key} className="col-4 pt-5">
                  <TextInput
                    className="text-sm"
                    isDark={true}
                    label={field.label}
                    placeholderText={field.placeholder}
                    disabled={field.isDisabled}
                    value={localFormData?.[field.key] || ''}
                    error={errors?.[field.key]} // Display error message if it exists
                    onChange={value => {
                      handleFormChange(
                        {
                          brandInfo: {...localFormData, [field.key]: value},
                        },
                        field.key,
                        value,
                        field.languages
                      )
                    }}
                  />
                </div>
              ))}
          </div>
          <div className="grid grid-cols-4 gap-4 pb-5">
            {/* Render multilingual fields */}
            {languages.map(lang => {
              const languageName = lang.language
              const language = lang.code
              return (
                <div key={language} className="col-4 pt-5">
                  <h5 className="heading pb-3 font-bold">{languageName}</h5>
                  {brandFields
                    ?.filter(field => field.languages)
                    ?.map(field => (
                      <TextInput
                        key={`${field.key}-${language}`}
                        className="pt-2 text-sm"
                        isDark={true}
                        label={field.label}
                        placeholderText={field.placeholder}
                        value={localFormData?.[field.key]?.[language] || ''}
                        error={errors?.[field.key]?.[language]} // Display error message for multilingual fields
                        disabled={field.isDisabled}
                        onChange={value => {
                          handleFormChange(
                            {
                              brandInfo: {
                                ...localFormData,
                                [field.key]: {
                                  ...localFormData?.[field.key],
                                  [language]: value,
                                },
                              },
                            },
                            field.key,
                            value,
                            language
                          )
                        }}
                      />
                    ))}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </PageContainer>
  )
}

export default BrandEdit
